import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagPH = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M24.999 0v25L7.32 42.678A24.922 24.922 0 0 0 25 50c13.807 0 25-11.193 25-25s-25-25-25-25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M24.999 0A24.922 24.922 0 0 0 7.32 7.322L25 25h25c0-13.807-11.193-25-25-25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m17.119 25-3.053-1.436 1.626-2.957-3.316.634-.42-3.349-2.31 2.463-2.309-2.463-.42 3.35-3.315-.635 1.626 2.957L2.175 25l3.053 1.436-1.626 2.957 3.316-.634.42 3.35 2.309-2.464 2.31 2.463.42-3.349 3.314.634-1.625-2.957L17.119 25ZM6.668 9.783l1.016 1.42 1.664-.527-1.036 1.405 1.016 1.42-1.657-.552-1.037 1.405.013-1.746-1.657-.552 1.665-.527.013-1.746ZM6.668 35.647l1.016 1.42 1.664-.527-1.036 1.405 1.016 1.42-1.657-.552-1.037 1.405.013-1.746-1.657-.552 1.665-.527.013-1.746ZM21.16 22.715l-1.017 1.42-1.664-.527 1.037 1.405-1.016 1.42 1.657-.552 1.036 1.405-.013-1.746 1.657-.552-1.665-.527-.013-1.746Z"
}));
FlagPH.displayName = 'FlagPH';
export default withFlagWrapper(FlagPH);
//# sourceMappingURL=index.js.map